import { Link } from 'react-router-dom';
import { ListChecks, AlertTriangle, PhoneCall, Inbox, Plane, ShieldAlert } from 'lucide-react';
import { Panel } from './Panel';

const Group = ({ icon: Icon, title, count, tone, children, testid }) => (
  <div className="rounded-2xl bg-[#F7F5FA] p-4" data-testid={testid}>
    <div className="flex items-center justify-between mb-2">
      <div className="flex items-center gap-2 text-[12.5px] font-semibold text-[#2D2833]"><Icon size={14} className={tone} /> {title}</div>
      <span className={`text-[12px] tabular-nums font-semibold ${count ? tone : 'text-[#8A7B95]'}`}>{count}</span>
    </div>
    {count === 0 ? <div className="text-[12px] text-[#8A7B95] italic">All clear</div> : <ul className="space-y-1 text-[12.5px] text-[#2D2833]">{children}</ul>}
  </div>
);

const inqName = (i) => i.form_submitter || i.client_name || 'Unnamed';

export const TodayCard = ({ t }) => (
  <Panel title="Today's to-dos" subtitle={t.date} icon={ListChecks} testid="ludo-dash-today">
    <div className="grid sm:grid-cols-2 xl:grid-cols-5 gap-3">
      <Group icon={AlertTriangle} title="Sessions without cover" count={t.uncovered_sessions.length} tone="text-[#8A3A3A]" testid="ludo-today-uncovered">
        {t.uncovered_sessions.map((s, i) => <li key={i}>{s.client_name} <span className="text-[#8A7B95]">{s.start}–{s.end}</span></li>)}
      </Group>
      <Group icon={Inbox} title="New inquiries" count={t.new_inquiries.length} tone="text-[#5E5068]" testid="ludo-today-new-inq">
        {t.new_inquiries.map((i) => <li key={i.inquiry_id}><Link to="/inquiries?disposition=new" className="hover:underline">{inqName(i)}</Link></li>)}
      </Group>
      <Group icon={PhoneCall} title="Follow-ups" count={t.followups.length} tone="text-[#B08A3A]" testid="ludo-today-followups">
        {t.followups.map((i) => <li key={i.inquiry_id}><Link to="/inquiries?disposition=contacted" className="hover:underline">{inqName(i)}</Link> <span className="text-[#8A7B95]">{i.received_iso}</span></li>)}
      </Group>
      <Group icon={Plane} title="Staff out today" count={t.time_off.length} tone="text-[#5E5068]" testid="ludo-today-time-off">
        {t.time_off.map((o, i) => <li key={i}>{o.name} <span className="text-[#8A7B95]">· {o.kind} until {o.until}</span></li>)}
      </Group>
      <Group icon={ShieldAlert} title="Authorizations" count={t.auth_alerts.length} tone="text-[#8A3A3A]" testid="ludo-today-auth">
        {t.auth_alerts.map((a) => <li key={a.client_id}>{a.client_name} <span className="text-[#8A7B95]">· {a.alert}</span></li>)}
      </Group>
    </div>
    <div className="text-[11px] text-[#8A7B95] mt-3" data-testid="ludo-today-sessions-count">{t.sessions_today} sessions on the board today</div>
  </Panel>
);

export default TodayCard;
